import request from "@/utils/request";

/**
 * 获取试听课程
 */
export function get_audition_course() {
    return request({
        url: "/papi/get_audition_course.json",
        method: "get"
    });
}

/**
 * 热度写入
 * @param id
 */
export function set_click_rate(id) {
    const data = {
        id: id
    };
    return request({
        url: "/papi/set_click_rate.json",
        method: "put",
        data: data
    });
}

/**
 * 获取用户关联类目
 * @param id
 */
export function get_class(id, keyword) {
    return request({
        url: `/papi/getclass/${id}.json`,
        method: "get",
        params: keyword ? { keyword } : {}
    });
}


/**
 * 获取对应目录下视频
 * @param id
 */
export function get_videos(id, keyword) {
    return request({
        url: `/papi/get_video/${id}.json`,
        method: "get",
        params: keyword ? { keyword } : {}
    });
}

export function get_video_info(id) {
    return request({
        url: `/papi/get_video_info/${id}.json`,
        method: "get",
    });
}

export function get_sts_info() {
    return request({
        url: `/papi/getSts.json`,
        method: "get",
    });
}

export function get_presigned_url(objectName) {
    return request({
        url: `/api/video/presigned-url`,
        method: "get",
        params: { objectName }
    });
}

